import React, { useState, useEffect } from "react";
import AuthHeader from "../../UI/AuthHeader/AuthHeader";
import AuthSideMenu from "../../UI/AuthSideMenu/AuthSideMenu";
import Button from "../../UI/Buttons/Button";
import { FaLongArrowAltLeft } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Modal } from "../../UI/Modal/Modal";
import Rules from "../Rules";
import BubbleFloat from "../../UI/BubbleFloat/BubbleFloat";
import { checkAuthenticatedUser, startExamSession } from "../../../utils/client-functions";
import { useErrorSetter } from "../../../hooks/useUiMessages";
import useExamStartGate from "../../../hooks/useExamStartGate";
import ExamReadyModal from "../ExamReadyModal";
import { ButtonThin } from "../../UI/Buttons/Buttons";
import { WassceSubjects } from "./WassceSubjects";

const Wassce = () => {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const [authMenuOpen, setAuthMenuOpen] = useState(false);
	const [subject, setSubject] = useState({});
	const [loading, setLoading] = useState(false);
	const [progressStatus, setProgressStatus] = useState("Gathering Exam Details...");
	const [progressPercentage, setProgressPercentage] = useState(0);
	const { examReady, handleOngoing, handleDoneEvent, confirmStartExam, closeGate } = useExamStartGate(navigate, dispatch);

	const isAuth = localStorage?.getItem("token");
	const errorSetter = useErrorSetter();

	useEffect(() => {
		const verifyAuth = async () => {
			try {
				await checkAuthenticatedUser();
			} catch (error) {
				errorSetter("Please login to access mock exams");
				sessionStorage.setItem("prevPath", "/user/dashboard/mock/wassce");
				navigate("/popin");
			}
		};
		verifyAuth();
	}, [navigate, errorSetter]);

	const toggleAuthMenu = () => setAuthMenuOpen(!authMenuOpen);

	const closeModalsAndReset = () => {
		setSubject({});
	};

	const handleStartExam = async () => {
		try {
			await checkAuthenticatedUser();
		} catch (error) {
            errorSetter("Please login to generate an exam");
            sessionStorage.setItem("prevPath", "/user/dashboard/mock/wassce");
			return navigate("/popin");
		}

		if (!subject || !subject.subject) {
			errorSetter("Please select a subject to start the exam");
			return;
		}

		setLoading(true);
		setProgressStatus("Gathering Exam Details...");
		setProgressPercentage(5);

		const payload = {
			subject: subject.subject,
			timeAlloted: subject.timeAlloted,
			description: subject.description,
			examName: "WASSCE",
		};

		try {
			await startExamSession({
				payload,
				tokenOverride: isAuth,
				onOngoing: (examDetails) => {
					setLoading(false);
					handleOngoing(examDetails);
				},
				onDone: (e) => {
					handleDoneEvent(e);
				},
				onError: (msg) => {
					setLoading(false);
					errorSetter(msg);
				},
				setLoading,
				setProgressStatus,
				setProgressPercentage,
			});
		} catch (error) {
			setLoading(false);
			errorSetter(
				error?.response?.data?.message ||
					error?.response?.data?.error ||
					"An Error Occurred. Please try again. If issue persists, please chat with us."
			);
			if (error?.response?.data?.openPricing) {
				window.dispatchEvent(new CustomEvent("openExamPricing"));
			}
		}
	};

	return (
		<div className="auth-container">
			<BubbleFloat />
			<div className="auth-container-inner content">
				<AuthHeader
					authMenuOpen={authMenuOpen}
					onClick={toggleAuthMenu}
					headerText="WASSCE MOCK"
				/>
				<AuthSideMenu opened={authMenuOpen} arrayDetails={[]} onSwitch={() => {}} />
				<div style={{ margin: "12px 0" }}>
					<Button secondaryLight={true} link="/user/dashboard/mock">
						<FaLongArrowAltLeft size="1rem" color="crimson" /> &nbsp;back to exams
					</Button>
				</div>

				<div className="BodyWrapper">
					<div className="BuildNavigator">
						<div className="ActiveNav">
							<span>1</span>Selection
						</div>
						<div>
							<span>2</span>Simulation
						</div>
						<div>
							<span>3</span>Insights & Tutor
						</div>
					</div>

					<div style={{ padding: "20px 5px" }}>
						<h4>Select a Subject to Start</h4>
						<div
							style={{
								display: "flex",
								justifyContent: "space-around",
								paddingLeft: 1,
								paddingBottom: 1,
								flexWrap: "wrap",
								marginTop: "20px",
							}}
						>
							{WassceSubjects.map((s, idx) => (
								<div
									key={idx}
									style={{
										marginBottom: "10px",
										maxWidth: "12rem",
										minWidth: "10rem",
									}}
								>
									<ButtonThin
										fontSize=".8rem"
										border="1px solid #E5E5EA"
										width={"100%"}
										height="40px"
										color="black"
										onClick={() => setSubject(s)}
									>
										{s.subject}
									</ButtonThin>
								</div>
							))}
						</div>
					</div>
				</div>
			</div>

			{Object.keys(subject).length >= 1 && !examReady && (
				<Rules
					examName={"West African Senior School Certificate Examination"}
					closeModalsAndReset={closeModalsAndReset}
					subject={subject}
					handleStartExam={handleStartExam}
				/>
			)}

			{loading && (
				<Modal
					header4={`PROCESSING... DO NOT RELOAD`}
					header3={progressStatus}
					progress={progressPercentage}
				/>
			)}

			{examReady && (
				<ExamReadyModal
					isOpen={examReady}
					onClose={closeGate}
					onStart={confirmStartExam}
					examLabel="WASSCE"
				/>
			)}
		</div>
	);
};

export default Wassce;

